import React, { useState } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { ItemCreateSellerReturnLitigationModal } from '@/types/modal';
import { ErrorModal, NoFooterModal, StandardModal } from '@/components/molecules/common/Modal';
import styles from '../Modal.module.scss';
import { useCreateItemReturnLitigation } from '@/hooks/item';
import { Skeleton } from '@mui/material';
import { TimelineType } from '@/types/item';

const ItemCreateSellerReturnLitigation: React.FC<{ modal: ItemCreateSellerReturnLitigationModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitNewTicketR = useCreateItemReturnLitigation();

  if (submitNewTicketR.kind === 'Completed') {
    return (
      <NoFooterModal
        title={t('oms_return_status.create_seller_return_litigation.title')}
        body={<p>{t('oms_return_status.create_seller_return_litigation.success.description')}</p>}
        onClose={onClose}
        modalName="item_create_seller_return_litigation"
      />
    );
  }

  if (submitNewTicketR.kind === 'Loading') {
    return (
      <NoFooterModal
        title={t('oms_return_status.create_seller_return_litigation.title')}
        body={
          <Skeleton
            height={20}
            variant="rounded"
          />
        }
        onClose={onClose}
        modalName="item_create_return_litigation"
      />
    );
  }

  if (submitNewTicketR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('oms_return_status.create_seller_return_litigation.title')}
        error={submitNewTicketR.error}
        useOriginMsg={true}
        onClose={onClose}
        containerStyle={{
          width: 400,
        }}
      />
    );
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);

    submitNewTicketR.mutate({
      productId: item.productId,
      clientType: TimelineType.SELLER,
      description: '',
      isReplacementTicket: false,
      itemReceived: false,
      reason: '',
      litigation: '',
    });
  };

  const body = (
    <div className={clsx([styles.text0875rem, styles.paddingY1rem, styles.breakLineWithEnter])}>
      <p>{t('oms_return_status.create_seller_return_litigation.description', { itemId: item.productId })}</p>
    </div>
  );

  return (
    <StandardModal
      title={t('oms_return_status.create_seller_return_litigation.title')}
      onClose={onClose}
      onSubmit={handleSubmit}
      closeLabel={t('common.cancel').toUpperCase()}
      submitLabel={t('common.submit').toUpperCase()}
      submittable={!isSubmitting}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_create_seller_return_litigation"
    />
  );
};

export default ItemCreateSellerReturnLitigation;
